const MULTIPLE_COMPANY_MANAGEMENT = {
    MCA_TOGGLE_ENABLED: {
        event: 'mca_toggle_enabled',
        eventProperties: {
            description: 'Triggered when an admin enables the MCA toggle for a Client Admin user',
            user_role: 'MCA',
        },
    },
    MCA_TOGGLE_DISABLED: {
        event: 'mca_toggle_disabled',
        eventProperties: {
            description: 'Triggered when an admin disables the MCA toggle for a Client Admin user',
            user_role: 'MCA',
        },
    },
    MCA_ACCOUNTS_ASSIGNED: {
        event: 'mca_accounts_assigned',
        eventProperties: {
            description:
                'Triggered when accounts are assigned to an MCA user via manual selection or CSV import',
            user_role: 'MCA',
        },
    },
    MCA_ACCOUNTS_REMOVED: {
        event: 'mca_accounts_removed',
        eventProperties: {
            description:
                'Triggered when accounts are removed from an MCA user individually or via Remove All',
            user_role: 'MCA',
        },
    },
    PPA_TOGGLE_ENABLED: {
        event: 'ppa_toggle_enabled',
        eventProperties: {
            description: 'Triggered when an admin enables the PPA toggle for a Partner Admin user',
            user_role: 'PPA',
        },
    },
    PPA_TOGGLE_DISABLED: {
        event: 'ppa_toggle_disabled',
        eventProperties: {
            description: 'Triggered when an admin disables the PPA toggle for a Partner Admin user',
            user_role: 'PPA',
        },
    },
    PPA_ACCOUNTS_ASSIGNED: {
        event: 'ppa_accounts_assigned',
        eventProperties: {
            description:
                'Triggered when accounts are assigned to a PPA user via manual selection or CSV import',
            user_role: 'PPA',
        },
    },
    PPA_ACCOUNTS_REMOVED: {
        event: 'ppa_accounts_removed',
        eventProperties: {
            description:
                'Triggered when accounts are removed from a PPA user individually or via Remove All',
            user_role: 'PPA',
        },
    },
};

export default MULTIPLE_COMPANY_MANAGEMENT;
